import _ from 'underscore';

(function () {
    "use strict";

    var moduleObj = moduler('generalRedirectBlock', {
        defaults: {
            apiUrl: '/api/GeneralRedirectData',

            defaultSecondDropdownValue: '-- Select a Report --',
            defaultSecondDropdownDataAttr: 'data-default-option',

            disabledClass: 'Select--disabled',

            listChangeEvent: 'change',
            hiddenPageId: '[name=pageId]',
            hiddenBlockId: '[name=blockId]',
            productList: '[data-list-type=product]',
            redirectList: '[data-list-type=redirect]',
            actionButton: '.RedirectButton',
            hideShowToggleClass: 'u-hiddenVisually'
        },

        init: function (module) {
            module.settings.apiUrl = module.$element.data("url");

            module.settings.initialProductSelection = module.$element.data("initial-product");

            module.$productList = module.$element.find(module.settings.productList);
            module.$redirectList = module.$element.find(module.settings.redirectList);
            module.$hiddenPageId = module.$element.find(module.settings.hiddenPageId);
            module.$hiddenBlockId = module.$element.find(module.settings.hiddenBlockId);
            module.$actionButton = module.$element.find(module.settings.actionButton);

            module.$productList.on(module.settings.listChangeEvent, module, moduleObj.listen.changedProductType);
            module.$redirectList.on(module.settings.listChangeEvent, module, moduleObj.listen.changedRedirectOption);
            module.$actionButton.on("click", module, moduleObj.analytics.trackReportView);

            moduleObj.actions.repopulateRedirectList(module);

            moduleObj.setInitialValue(module);
        },

        setInitialValue: function (module) {
            var allDropdownValues = _(module.$productList[0].options).pluck("value");

            if (allDropdownValues.indexOf(module.settings.initialProductSelection) != -1) {
                module.$productList.val(module.settings.initialProductSelection);
                module.$productList.trigger(module.settings.listChangeEvent);
            }
        },

        analytics: {
            getTypePrefix: function (module) {
                return module.$element.data("block-type") + " ";
            },

            trackProductChange: function (module) {
                var selectedOption = module.$productList.find("option:selected");

                if (typeof gtag !== 'undefined' && !!selectedOption) {
                    gtag('event', 'Select Product', {
                        'event_category': moduleObj.analytics.getTypePrefix(module) + 'Redirect Block',
                        'event_label': selectedOption.text() + " [" + selectedOption.val() + "]"
                    });
                }
            },

            trackReportChange: function (module) {
                var selectedOption = module.$redirectList.find("option:selected");

                if (typeof gtag !== 'undefined' && !!selectedOption) {
                    gtag('event', 'Select Report', {
                        'event_category': moduleObj.analytics.getTypePrefix(module) + 'Redirect Block',
                        'event_label': selectedOption.text() + " [" + selectedOption.val() + "]"
                    });
                }
            },

            trackReportView: mo.event(function (module, event) {
                var selectedProduct = module.$productList.find("option:selected");
                var selectedReport = module.$redirectList.find("option:selected");

                if (typeof gtag !== 'undefined') {
                    gtag('event', 'Click Go', {
                        'event_category': moduleObj.analytics.getTypePrefix(module) + 'Redirect Block',
                        'event_label': selectedProduct.text() + " - " + selectedReport.text() + " [" + selectedReport.val() + "]"
                    });
                }
            })
        },

        listen: {

            changedRedirectOption: mo.event(function (module, event) {
                event.preventDefault();

                var redirectListValue = module.$redirectList.val();

                var defaultAttrValue = module.$redirectList.attr(module.settings.defaultSecondDropdownDataAttr);
                defaultAttrValue = (!!defaultAttrValue && defaultAttrValue.length > 0) ? defaultAttrValue : module.settings.defaultSecondDropdownValue;

                if (!!redirectListValue && redirectListValue != defaultAttrValue && redirectListValue.length > 0) {
                    moduleObj.analytics.trackReportChange(module);
                    module.$actionButton.removeClass(module.settings.hideShowToggleClass);
                    module.$actionButton.attr("href", redirectListValue);
                } else {
                    module.$actionButton.addClass(module.settings.hideShowToggleClass);
                }
            }),

            changedProductType: mo.event(function (module, event) {
                event.preventDefault();

                moduleObj.actions.repopulateRedirectList(module);
            })

        },

        resets: {
            resetRedirectList: function (module, shouldSeedDefault) {
                moduleObj.resets.resetActionButton(module);
                module.$redirectList.html("");

                if (document.activeElement == module.$redirectList[0]) {
                    module.$redirectList.blur();
                }

                moduleObj.disableDropdown(module, module.$redirectList);

                if (shouldSeedDefault == undefined && !shouldSeedDefault) {
                    var defaultOption = $("<option/>");

                    var defaultAttrValue = module.$redirectList.attr(module.settings.defaultSecondDropdownDataAttr);
                    defaultAttrValue = (!!defaultAttrValue && defaultAttrValue.length > 0) ? defaultAttrValue : module.settings.defaultSecondDropdownValue;

                    defaultOption.html(defaultAttrValue);

                    module.$redirectList.append(defaultOption);
                }
            },

            resetActionButton: function (module) {
                module.$actionButton.addClass(module.settings.hideShowToggleClass);
            }
        },

        actions: {

            repopulateRedirectList: function (module) {
                moduleObj.resets.resetRedirectList(module, false);

                var productId = module.$productList.val();

                if (!!productId && productId.length > 0) {
                    var apiUrl = module.settings.apiUrl;
                    if (window.location.search) {
                        apiUrl += window.location.search;
                    }
                    $.get(apiUrl, {
                        pageId: module.$hiddenPageId.val(),
                        blockId: module.$hiddenBlockId.val(),
                        productId: module.$productList.val()
                    }, function (data, responseStatus) {
                        if (responseStatus == "success") {
                            if (!!data.Items && data.Items.length > 0) {
                                moduleObj.resets.resetRedirectList(module);

                                moduleObj.analytics.trackProductChange(module);

                                moduleObj.enableDropdown(module, module.$redirectList);

                                _.each(data.Items, function (redirectOption, redirectOptionIndex) {
                                    var newOption = $("<option/>");

                                    newOption.html(redirectOption.Text);
                                    newOption.val(redirectOption.Value);

                                    module.$redirectList.append(newOption);

                                    if (redirectOptionIndex == 0) {
                                        module.$redirectList.trigger(module.settings.listChangeEvent);
                                    }
                                });
                            }
                        }
                    });
                }
            }

        },

        disableDropdown: function (module, $element) {
            $element.addClass(module.settings.disabledClass);
            $element.prop("disabled", true);
        },

        enableDropdown: function (module, $element) {
            $element.removeClass(module.settings.disabledClass);
            $element.prop("disabled", false);
        },
    });

})();